import PropTypes from "prop-types";
import { decimalAddZero, floatAdd, floatDiv } from "../../../service/common";

export const CustomTooltip = ({
  payload = [],
  label,
  active,
  isDiffColor = false,
  isStack = false,
  stackOptions = {},
  tooltipOptions = {},
  isTenThousandUnit = false,
  tooltipKey = null,
}) => {
  if (active) {
    return (
      <div className="line-height-3 bg-white p-2">
        <div className="font-bold">
          {tooltipKey ? payload[0]?.payload?.[tooltipKey] : label}
        </div>
        {payload.map((item) => (
          <div
            key={item.dataKey}
            style={{ color: isDiffColor ? item.payload.color : item.color }}
          >{`${item.name}：${decimalAddZero({
            rawVal: floatDiv(item.value, isTenThousandUnit ? 10000 : 1),
            decimalCount: 2,
            isZero: false,
          })}${tooltipOptions.unit?.[item.dataKey] ?? ""}`}</div>
        ))}
        {isStack && (
          <div>{`${stackOptions.label ?? "總和"}：${decimalAddZero({
            rawVal: floatDiv(
              payload.reduce(
                (pre, cur) =>
                  floatAdd(
                    pre,
                    (stackOptions.sumKeys ?? []).includes(cur.dataKey)
                      ? cur.value
                      : 0
                  ),
                0
              ),
              isTenThousandUnit ? 10000 : 1
            ),
            decimalCount: 0,
          })}`}</div>
        )}
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      dataKey: PropTypes.string,
      name: PropTypes.string,
      value: PropTypes.number,
      payload: PropTypes.object,
    }),
  ),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  active: PropTypes.bool,
  isDiffColor: PropTypes.bool,
  isStack: PropTypes.bool,
  stackOptions: PropTypes.shape({
    label: PropTypes.string,
    sumKeys: PropTypes.arrayOf(PropTypes.string),
  }),
  tooltipOptions: PropTypes.shape({
    unit: PropTypes.object,
  }),
  isTenThousandUnit: PropTypes.bool,
  tooltipKey: PropTypes.string,
};
